import { useAtomValue } from 'jotai';
import { $WebUser, $AppIdConfig } from '@lemon8/web-app-shared/atom';
import { FC } from 'react';

import './style.scss';

export const Debug: FC = () => {
  const { webId } = useAtomValue($WebUser);
  const { wapId } = useAtomValue($AppIdConfig);

  const getWebId = async () => {
    await navigator.clipboard.writeText(webId).catch(() => ({}));

    alert(`web id copied: ${webId}`);
  };

  const clearLocalStorage = () => {
    window.localStorage.clear();

    alert('all localStorage cleared!');
  };

  return (
    <div className="debug-tool">
      <div className="web-id" onClick={getWebId}>
        {` Preview ${wapId}`}
      </div>
      <div className="clear" onClick={clearLocalStorage}>
        clear storage
      </div>
    </div>
  );
};
